import { axios } from '@/utils/request'

// 协议管理 - 协议列表
export function getAgreementList(parameter) {
  return axios({
    url: '/merchant.php/agreement/getList',
    method: 'get',
    params: parameter
  })
}

// 协议管理 - 协议详情
export function getAgreementDetail(parameter) {
  return axios({
    url: '/merchant.php/agreement/detail',
    method: 'get',
    params: parameter
  })
}

// 协议管理 - 编辑协议
export function postAgreementEdit(data) {
  return axios({
    url: '/merchant.php/agreement/edit',
    method: 'post',
    data: data
  })
}

// 协议管理 - 编辑协议
export function addPrandAgreement(data) {
  return axios({
    url: '/merchant.php/agreement/update',
    method: 'post',
    data: data
  })
}
